import React, { useEffect, useState } from "react";
import { collection, getDocs, getFirestore } from "firebase/firestore";
import { Link } from "react-router-dom";

function SidebarCatalogs() {
  const [catalogs, setCatalogs] = useState([]);

  const db = getFirestore();

  useEffect(() => {
    const fetchCatalogs = async () => {
      const snapshot = await getDocs(collection(db, "catalogs"));
      const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setCatalogs(data);
    };
    fetchCatalogs();
  }, [db]);
  
  return (
    <ul className="mt-3 nav nav-pills flex-column mb-auto">
      {catalogs.map((catalog) => (
        <li key={catalog.id} className="nav-item dropdown">
          <div
            className="nav-link dropdown-toggle link-light"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {catalog.catalogName}
          </div>
          <ul className="dropdown-menu">
            {catalog.collections.map((col) => (
              <Link key={col} to={`catalog/${catalog.catalogName}/${col}`}>
                <div className="dropdown-item">{col}</div>
              </Link>
            ))}
          </ul>
        </li>
      ))}
    </ul>
  );
}

export default SidebarCatalogs;
